import { Link } from 'react-router-dom';
import { articles } from '@/mocks/homeData';
import { useScrollReveal } from '@/hooks/useScrollReveal';

export default function FeaturedArticles() {
  const featured = articles.filter((a) => a.featured).slice(0, 4);
  const { ref, animated } = useScrollReveal();

  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="container-custom">
        <div className={`text-center mb-10 md:mb-14 ${animated ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'}`} style={{ transition: 'all 0.6s ease-out' }} ref={ref}>
          <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-900">
            精选内容
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-500 max-w-xl mx-auto">
            精心挑选的少女风格内容，涵盖穿搭、美妆、生活与兴趣，总有你喜欢的~
          </p>
        </div>

        <div className={`grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 stagger-children ${animated ? 'animated' : ''}`}>
          {featured.map((article) => (
            <Link
              key={article.slug}
              to={`/article/${article.slug}`}
              className="stagger-item group bg-background-100 rounded-lg overflow-hidden cursor-pointer transition-all duration-300 hover:scale-[1.02]"
            >
              <div className="relative w-full h-48 overflow-hidden">
                <img
                  src={article.coverImage}
                  alt={article.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <span className="absolute top-3 left-3 px-3 py-1 rounded-full bg-primary-500 text-white text-xs font-medium whitespace-nowrap">
                  {article.category}
                </span>
              </div>
              <div className="p-4">
                <h3 className="text-sm md:text-base font-heading font-bold text-foreground-900 line-clamp-2 leading-snug group-hover:text-primary-600 transition-colors">
                  {article.title}
                </h3>
                <p className="mt-2 text-xs text-foreground-500 line-clamp-2 leading-relaxed">
                  {article.excerpt}
                </p>
                <div className="flex items-center gap-3 mt-4 pt-3 border-t border-background-200/70">
                  <div className="w-6 h-6 rounded-full overflow-hidden flex-shrink-0">
                    <img
                      src={article.authorAvatar}
                      alt={article.author}
                      className="w-full h-full object-cover"
                    />
                  </div>
                  <span className="text-xs text-foreground-500">{article.author}</span>
                  <span className="text-xs text-foreground-400 ml-auto">{article.publishDate}</span>
                </div>
              </div>
            </Link>
          ))}
        </div>

        <div className="text-center mt-10">
          <Link
            to="/category/fashion"
            className="inline-flex items-center gap-2 px-6 py-3 rounded-full border border-primary-300 text-primary-600 text-sm font-medium hover:bg-primary-50 transition-colors duration-200 whitespace-nowrap cursor-pointer"
          >
            查看全部内容
            <i className="ri-arrow-right-line text-base"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}